import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import RecoveryPasswordForm from "./RecoveryPasswordForm/RecoveryPasswordForm";
import {authApi} from "../../api/authApi";
import {CircleLoader} from "react-spinners";
import styles from './RecoveryPassword.module.css'
import RecoveryPasswordRequest from "./RecoveryPasswordRequest/RecoveryPasswordRequest";
import {UIText} from "../../enums/UIText/UIText";
import {EnumLanguage} from "../../enums/EnumLanguage";
import {useAppSelector} from "../../hooks/redux";
import {getLanguage} from "../../store/selectors/appSelector";
import {UXRecovery} from "../../enums/UXText/UXRecovery";
import {getTextByLanguage} from "../../enums/utils/getTextByLanguage";


const RecoveryPassword = () => {

    const {recoveryKey} = useParams()


    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>('')


    const language = useAppSelector(getLanguage)


    useEffect(() => {
        document.title = `${getTextByLanguage(UXRecovery.title, language)} - ${UIText.mis[EnumLanguage.ru]}`
    }, [language])


    useEffect(() => {
        setIsLoading(true)
        if (recoveryKey) {
            authApi.checkRecoveryPasswordRecord(recoveryKey).then((data) => {
                setIsLoading(false)
            }).catch(e => {
                console.log(e)
                setIsError(true)
                setErrorMessage(e.response.data.message)
                setIsLoading(false)
            })
        }
    }, [recoveryKey])


    if (isLoading) {
        return (
            <div className={styles.loadingWrapper}>
                <CircleLoader color="#B29E7D"/>
            </div>
        )
    }

    return (
        <div style={{width: '100%'}}>
            <LayoutContentWrapper>
                <ContentHeader title={'Восстановление пароля'} description={errorMessage}/>
                {!isError && recoveryKey && <RecoveryPasswordForm recoveryKey={recoveryKey}/>}
                {isError && <RecoveryPasswordRequest/>}
            </LayoutContentWrapper>
        </div>
    );
};

export default RecoveryPassword;